export const MAX_ITEM_IMAGE_COUNT = 30; //아이템 생성 최대 개수

export const MAX_UPLOAD_PRICE = 999999990; // 업로드 최대 가격
export const 자동주문취소_스케줄러_시간 = 168;

export const refundLogixTypes = [
  { title: '판매자 지정 택배사에서 수거', value: 'REFUND_LOGIX-TYPE_SELLER_DIRECT' },
  {
    title: '구매자가 착불로 발송',
    value: 'REFUND_LOGIX-TYPE_BUYER_DIRECT',
  },
  {
    title: '둘 다',
    value: 'REFUND_LOGIX-TYPE_ALL',
  },
];

/**
 * @deprecated 메타데이터 사용하기.
 */
export const 카테고리_그룹_코드_이름_매핑: Record<string, string> = {
  'MAPPING-GROUP_TYPE_KIDS-MEN': '키즈 남',
  'MAPPING-GROUP_TYPE_KIDS-UNISEX': '키즈',
  'MAPPING-GROUP_TYPE_KIDS-WOMEN': '키즈 여',
  'MAPPING-GROUP_TYPE_MEN': '남성',
  'MAPPING-GROUP_TYPE_UNISEX': '유니섹스',
  'MAPPING-GROUP_TYPE_WOMEN': '여성',
};
